<template>
  <div class="admins-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'admins-page',
}
</script>
